// ----------------------------------------------------------------------
// <copyright file="Izenda.ExportPageService.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  function ExportPageService() {
    this.addExportLoading = null;
    this.removeExportLoading = null;
  }

  /**
   * Register export loading indicator
   * @param {object}  addFunc
   * @param {object}  removeFunc
   * @returns {object}
   */
  ExportPageService.prototype.registerExportLoadingChanged = function (addFunc, removeFunc, updateErrorFunc) {
    this.addExportLoading = addFunc;
    this.removeExportLoading = removeFunc;
    this.updateError = updateErrorFunc;
    return function () {
      delete this.addExportLoading;
      delete this.removeExportLoading;
      delete this.updateError;
    }.bind(this);
  };

  /**
   * Start export loading indicator
   * @param {object}  exportFile
   */
  ExportPageService.prototype.startExportLoading = function (exportFile) {
    this.addExportLoading(exportFile);
  };

  /**
   * Start export loading indicator
   * @param {string}  fileName
   */
  ExportPageService.prototype.endExportLoading = function (fileName) {
    this.removeExportLoading(fileName);
  };

  /**
   * Update error for loading indicator
   * @param {string}  fileName
   */
  ExportPageService.prototype.updateError = function(fileName) {
    this.updateError(fileName);
  }

  module.exports = ExportPageService;
}();



// WEBPACK FOOTER //
// ./ui/share/page/Izenda.ExportPageService.js